import React from 'react';
import './ProgressBar.scss';

function ProgressBar(props) {
    const { title, step, totalStep = 3 } = props;
    const currentProgress = (100 / totalStep) * step;
    return (
        <div className="progress-container mr-t20 mr-b20">
            <div className="pd-l20 pd-r20 display-flex align-items-center justify-space-between">
                <span className="fsp16">{title}</span>
                <span className="text-color_pale_black fw500 fsp13">{step} of {totalStep}</span>
            </div>
            <div className="progress-bar mr-t8 pos-rel">
                <span className="current-progress pos-abs" style={{ width: `${currentProgress}%` }}></span>
            </div>
        </div>
    );
}


export default ProgressBar;
